import { Menu } from "antd";
import { Header } from "antd/lib/layout/layout";
import { ItemType } from "antd/lib/menu/interface";
import { ReactElement } from "react";
import logo from "@common/assets/logo.png";
import s from "./AppHeader.module.scss";

type AppHeaderProps = {
  leftItems?: ItemType[];
  rightItems?: ItemType[];
};

// Header brandizzato condiviso: la barra chiara Helioty (logo + menu). È
// app-agnostica — non conosce ruoli né privilegi: ogni shell (tenant/console/
// public) le passa i propri item. Senza item mostra solo il logo (rotte pubbliche).
export function AppHeader({ leftItems = [], rightItems = [] }: AppHeaderProps): ReactElement {
  const hasMenus: boolean = leftItems.length > 0 || rightItems.length > 0;

  return (
    <Header className={s.container}>
      <a href="https://www.helioty.com/" target="_blank" rel="noreferrer">
        <img src={logo} alt="HeliotySRL" className={s.logo} />
      </a>
      {hasMenus && (
        <div className={s.menuContainer}>
          {leftItems.length > 0 && (
            <Menu className={s.leftMenu} selectable={false} mode="horizontal" items={leftItems} />
          )}
          {rightItems.length > 0 && (
            <Menu className={s.rightMenu} selectable={false} mode="horizontal" items={rightItems} />
          )}
        </div>
      )}
    </Header>
  );
}
